module.exports = __webpack_public_path__ + "img/1440.2278dc27.jpg";